// src/components/common/LogoutModal.js
import React from "react";
import "./LogoutModal.css";

const LogoutModal = ({ show, onClose, onConfirm }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="modal-title">Confirm Logout</h3>
                <p className="modal-message">Are you sure you want to logout?</p>
                <div className="modal-actions">
                    <button className="btn-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-confirm" onClick={onConfirm}>
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LogoutModal;
